import { render, staticRenderFns } from "./DocumentBusiness.vue?vue&type=template&id=4f117c8c&scoped=true"
import script from "./DocumentBusiness.vue?vue&type=script&lang=js"
export * from "./DocumentBusiness.vue?vue&type=script&lang=js"
import style0 from "./DocumentBusiness.vue?vue&type=style&index=0&id=4f117c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f117c8c",
  null
  
)

export default component.exports